// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"350":"dbfdce5e","583":"cca77ad0"}[chunkId] + ".chunk.css";
};